const sizes = { sm: "w-12 h-12 text-xl", md: "w-16 h-16 text-2xl", lg: "w-20 h-20 text-3xl", xl: "w-24 h-24 text-4xl" };

export default function Avatar({ user, size = "md", color = "bg-[#2E7D6B]", className = "" }) {
  const cls = `${sizes[size]} rounded-full flex items-center justify-center shrink-0 overflow-hidden ${className}`;
  if (user?.avatar) {
    return <img src={user.avatar} alt={user.name} data-testid="avatar-img" className={`${cls} object-cover border-2 border-white shadow-sm`} />;
  }
  return (
    <span data-testid="avatar-initial" className={`${cls} ${color} text-white font-display font-bold`}>
      {(user?.name || "?").charAt(0)}
    </span>
  );
}

export function resizeImage(file, max = 320) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      resolve(c.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("bad image")); };
    img.src = url;
  });
}
